import { KeyboardBackspaceRounded } from '@mui/icons-material';
import { ReactElement } from 'react';

// Components.
import { Link } from 'components';
import { Box, Card, Grid, Stack, Typography } from '@mui/material';

// Hooks.
import { useClickEvent } from 'hooks';

// Styles
import styles from './Featured.module.scss';

export const Featured = (): ReactElement => {
  const fireEvent = useClickEvent();

  return (
    <Box className={styles.container}>
      <h4 className={styles.featuredHeader}>Popular CME Searches</h4>

      {/* MATE Act */}
      <Grid container spacing={6}>
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <Card className={styles.card} variant="outlined">
            <Stack direction="column" justifyContent="space-between" padding="16px" width="100%">
              <Typography variant="h6">MATE Act</Typography>
              <Typography variant="body2">
                Education related to substance use disorders, effective treatment planning, pain management, and
                substance misuse.
              </Typography>
              <Link
                className={styles.go}
                onClick={() => fireEvent({ EventAction: 'Links', EventLabel: 'Preoperative Medication' })}
                to="/activity/search/MateAct"
              >
                <KeyboardBackspaceRounded />
              </Link>
            </Stack>
          </Card>
        </Grid>

        {/* Free And Online */}
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <Card className={styles.card} variant="outlined">
            <Stack direction="column" justifyContent="space-between" padding="16px" width="100%">
              <Typography variant="h6">Free And Online</Typography>
              <Typography variant="body2">Free accredited continuing education you can complete online.</Typography>
              <Link
                className={styles.go}
                onClick={() => fireEvent({ EventAction: 'Links', EventLabel: 'Clinical Care Transfusion' })}
                to="/activity/search?participationFee[]=No%2C%20it%27s%20free&locationTypes[]=Live-Streamed,Online&type[]=Conference,In-House%20Seminar,Online%20Learning&registration[]=Open%20to%20all"
              >
                <KeyboardBackspaceRounded />
              </Link>
            </Stack>
          </Card>
        </Grid>

        {/* CME that Counts for MOC/CC */}
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <Card className={styles.card} variant="outlined">
            <Stack direction="column" justifyContent="space-between" padding="16px" width="100%">
              <Typography variant="h6">CME that Counts for MOC/CC</Typography>
              <Typography variant="body2">
                Education that offers Maintenance for Certification or Continuous/Continuing Certification Credit.
              </Typography>
              <Link
                className={styles.go}
                onClick={() => fireEvent({ EventAction: 'Links', EventLabel: 'Hospital Diagnostic Cases' })}
                to="/activity/search?isMoc=true"
              >
                <KeyboardBackspaceRounded />
              </Link>
            </Stack>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};
